<template>
  <div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <!-- :limit="limitNum" -->
    <el-upload
      :action="imageUrl"
      :data="imageData"
      :on-change="checkType"
      :show-file-list="true"
      :on-preview="handlePictureCardPreview"
      :on-success="handleUploadSuccess"
      list-type="picture-card"
      :on-remove="handleRemove"
      :file-list="fileList"
      :accept="imageType"
      ref="upload"
    >
      <i class="el-icon-plus"></i>
      <div slot="tip" class="el-upload__tip">仅支持JPG、PNG、JPEG格式</div>
    </el-upload>
  </div>
</template>
<style scoped>
</style>
<script>
// import api from "@/views/data-input/api";
export default {
  name: "unloadFile",
  props: {
    imageData: Object,
    imageUrl:String,
    onSuccess: Function,
    beforeAvatarUpload: Function,
    onRemove: Function,
    uploadObj: Object,
    imageType: String,
    resourceUrl: String,
    limitNum: 4
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      fileList: [],
      // dialogImageUrlList: [],
      UploadImageUrl:''
    };
  },
  methods: {

    // 文件判断
    checkType(file, fileList) {
      let fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      this.fileList = fileList;
      // this.fileList = fileList.slice(-1);
      if (fileType !== "jpg" && fileType !== "jpeg" && fileType !== "png") {
        this.$message("图片格式不正确!");
        return false;
      }
      if (file.size / 1024 / 1024 > 2) {
        this.$message("图片大小不能超过2M!");
        return false;
      }
      // this.dialogImageUrlList.push(file.url)
      this.dialogImageUrl = file.url;
    },

    // 文件上传前
    changeUpload(file, fileList) {
      // debugger
    },

    // 自定义请求
    uploadImg(file, fileList) {
      // debugger
    },

    //删除图片
    handleRemove(file, fileList) {
      // debugger
      console.log(file);
      
    },

    //预览
    handlePictureCardPreview(file) {
      // debugger;
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传成功
    handleUploadSuccess(file) {
      this.UploadImageUrl = file.file
      // debugger;
    },

    // 清空图片
    clearImg(){
      // debugger
      this.$refs.upload.clearFiles()
    }
  }
};
</script>